import React from "react";

import "./Tickets.scss";

const TicketSummary = React.memo(({ submittedBy, type, subject, createdAt }) => {
   return (
      <div className="ticket-summary">
         <div className="ticket-summary__header">
            <p>Ticket summary</p>
         </div>

         <div className="ticket-summary__content">
            <div className="ticket-summary__field">
               <label>User email</label>
               <p className="ticket-summary__text">{submittedBy}</p>
            </div>

            <div className="ticket-summary__field">
               <label>Type</label>
               <div className="ticket-summary__type">{type}</div>
            </div>

            <div className="ticket-summary__field">
               <label>Ticket subject</label>
               <p className="ticket-summary__text">{subject}</p>
            </div>

            <div className="ticket-summary__field">
               <label>Creation date</label>
               <p className="ticket-summary__text">{createdAt}</p>
            </div>
         </div>
      </div>
   );
});

export default TicketSummary;
